<template>
  <div id="responsibility" class="responsibility">
    <div class="zy_constr">
      <img
        src="https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/6f7b2a75-545d-4332-abb6-10d80d7fcc83.png"
        class="responsibility-logo"
      />
      <div class="responsibility-desc">
        <div v-for="(item, index) in RESPONSIBILITY.desc" :key="index" class="responsibility-desc__row">
          {{ item }}
        </div>
      </div>

      <div class="responsibility-list">
        <a :href="`/allreps?id=item.id`" v-for="item in RESPONSIBILITY.list" :key="item.id" class="responsibility-item">
          <img v-lazy="item.img" alt="" class="responsibility-item__img" />
          <div class="responsibility-item__title">
            <span class="responsibility-item__title__text">{{ item.title }}</span>
          </div>
        </a>
        <!-- 占位符: 解决小米手机谷歌浏览器，小米手机 QQ浏览器,oppo pad自带浏览器  zy_about_advantage_list设置padding-right 后不生效的bug-->
        <div v-if="isMobile" class="responsibility-item_placeholder"></div>
      </div>

      <a class="responsibility-more" href="/allreps">其它公益活动<i class="responsibility-more__icon"></i></a>
    </div>
  </div>
</template>

<script>
import { RESPONSIBILITY } from '@/config';
import { isMobile } from '@/utils/utils';
export default {
  name: 'Responsibility',
  data: function () {
    return {
      RESPONSIBILITY,
      isMobile
    };
  }
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/function.scss';
.phone_app,
.resp_app_tit {
  display: none;
}

.responsibility {
  padding: 60px 0;
}

.responsibility-logo {
  display: block;
  width: 252px;
  margin: 0 auto;
}

.responsibility-desc {
  margin-top: 48px;
  font-size: 16px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}

.responsibility-desc__row {
  margin-top: 12px;
  &:first-child {
    margin-top: 0;
  }
}

.responsibility-list {
  display: flex;
  margin-top: 48px;
}

.responsibility-item {
  border-radius: 16px;
  display: block;
  margin-left: 16px;
  width: 278px;
  height: 387px;
  position: relative;
  overflow: hidden;
  &:first-child {
    margin-left: 0;
  }
  &:hover {
    .responsibility-item__img {
      transform: scale(1.1);
    }
  }
}

.responsibility-item__img {
  display: block;
  width: 100%;
  transition: all 0.3s;
}

.responsibility-item__title {
  height: 120px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  text-align: center;
  box-sizing: border-box;
  padding-top: 70px;
  &__text {
    font-size: 20px;
    color: #fff;
  }
}

.responsibility-more {
  margin-top: 48px;
  font-size: 16px;
  color: #1680fc;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 28px;
  &:hover {
    color: #0f5ab0;
    .responsibility-more__icon {
      transform: translateX(6px);
    }
  }
}

.responsibility-more__icon {
  display: block;
  width: 16px;
  height: 16px;
  margin-left: 2px;
  position: relative;
  transition: all 0.3s ease;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-75%, -50%) rotate(45deg);
    width: 8px;
    height: 8px;
    border-top: 1px solid #1680fc;
    border-right: 1px solid #1680fc;
  }
}

.S {
  .responsibility {
    padding: rem(36 * 3) 0 rem(72);
  }
  .responsibility-logo {
    width: rem(366);
  }
  .responsibility-desc {
    margin-top: rem(72);
    padding: rem(0) rem(48);
    font-size: rem(42);
    line-height: rem(75);
  }
  .responsibility-desc__row {
    margin-top: rem(36);
  }
  .responsibility-list {
    margin-top: rem(72);
    padding-left: rem(48);
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    overflow-x: auto;
    /* 隐藏滚动条 */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }
    
  }
  .responsibility-item {
    flex-shrink: 0;
    width: rem(480);
    height: rem(720);
    margin-left: rem(24);
    border-radius: rem(42);
    &:first-child {
      margin-left: 0;
    }
    &:hover {
      .responsibility-item__img {
        transform: translateY(rem(30)) scale(1.1);
      }
    }
  }
  .responsibility-item_placeholder {
    flex-shrink: 0;
    width: rem(48);
  }
  .responsibility-item__img {
    transform: translateY(rem(30)) scale(1.1);
  }
  .responsibility-item__title {
    height: rem(270);
    padding-top: rem(186);
  }
  .responsibility-item__title__text {
    font-size: rem(36);
  }
  .responsibility-more {
    margin-top: rem(72);
    font-size: rem(42);
    &:hover {
      color: #1680fc;
      .responsibility-more__icon {
        transform: none;
      }
    }
    .responsibility-more__icon {
      width: rem(36);
      height: rem(36);
      &::after {
        width: rem(18);
        height: rem(18);
      }
    }
  }
}
</style>
